<template>
  <div>
    <div class="header-group">
      <img
        ref="logo"
        class="icon"
        src="../assets/logo.png"
        alt
        v-show="false"
      />
      <h2 style="margin: 0px; font-weight: bold">STAFF PAYSLIPS</h2>
      <button
        class="button dark-blue"
        @click="download"
        v-if="monthlyAttendance"
      >
        Download
      </button>
    </div>
    <div>
      Your monthly payslip refers to the period of the 26th of the previous
      month to the 25th of the Payslip's period
    </div>
    <div class="loader" v-if="loading" />
    <div class="box" style="margin-top: 10px" v-else>
      <div class="box-header-group">
        <h3 style="margin: 0px; font-weight: bold">
          {{ `${model.employee_name} Payslip` }}
        </h3>
        <h3 style="margin: 0px">{{ `${monthStr} ${year}` }}</h3>
      </div>
      <div class="box-content-group">
        <div class="emp-details-group">
          <div>
            <div style="font-weight: bold">{{ model.employee_name }}</div>
            <div v-if="model.address">{{ model.address }}</div>
            <div v-if="model.email">{{ model.email }}</div>
          </div>
          <div>
            <div v-if="model.npwp_no">{{ `NPWP No: ${model.npwp_no}` }}</div>
            <div v-if="model.wajib_pajak_status">
              {{ `Status Wajib Pajak: ${model.wajib_pajak_status}` }}
            </div>
          </div>
        </div>
        <table style="margin-top: 10px">
          <thead>
            <tr>
              <th scope="col">Description</th>
              <th scope="col">Value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(it, idx) in tableItems" :key="idx">
              <!-- only show row if item > 0 and the cur model is not admin OR show them all for admin -->
              <template
                v-if="
                  (model[it.id] > 0 && profile.role !== 'admin') ||
                    profile.role === 'admin'
                "
              >
                <td>
                  {{ it.desc }}
                  <b v-if="it.infoOnly">{{ `- Paid in by school` }}</b>
                </td>
                <td v-if="it.infoOnly">
                  <div>{{ `(${toRupiah(model[it.id])})` }}</div>
                </td>
                <td :class="it.isDeduct ? 'red-label' : 'green-label'" v-else>
                  <div class="table-value-group">
                    <div v-if="!isEditing">{{ toRupiah(model[it.id]) }}</div>
                    <input
                      type="number"
                      v-model.number="editableModel[it.id]"
                      v-else
                    />
                    <div style="font-weight: bold">
                      {{ it.isDeduct ? '-' : '+' }}
                    </div>
                  </div>
                </td>
              </template>
            </tr>
            <tr>
              <td>Attendance</td>
              <td class="red-label">
                <div class="table-value-group">
                  <div class="loader" v-if="!monthlyAttendance"></div>
                  <div v-else>{{ toRupiah(totalAttendanceDeductions) }}</div>
                  <div style="font-weight: bold">-</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          style="
            border-top-color: #bdc3c7;
            margin-top: 20px;
            border-top: double;
          "
        />
        <table style="margin-top: 20px">
          <tfoot>
            <tr>
              <td>Grand Total</td>
              <td>{{ total }}</td>
            </tr>
          </tfoot>
        </table>
        <div style="margin-top: 10px; display: flex; flex-flow: column">
          <div style="font-weight: bold">Note</div>
          <div v-if="!isEditing">{{ editableModel.note }}</div>
          <textarea rows="4" cols="50" v-model="editableModel.note" v-else />
        </div>
        <div class="footer">
          <div>{{ payDay }}</div>
          <div>{{ `Bank Account: ${model.bank_acc_no}` }}</div>
          <div style="padding: 25px">
            <div v-if="isEditable && !isSubmitting">
              <div class="footer-btn-group">
                <button
                  class="button-square green"
                  style="font-size: 18px"
                  @click="isEditing = true"
                  v-if="!isEditing"
                >
                  <i style="margin-bottom: 5px" class="fas fa-edit"></i>
                  <div style="margin-right: 5px">Edit</div>
                </button>
                <button
                  class="button-square"
                  style="margin-right: 10px"
                  @click="updateEditable()"
                  v-if="isEditing"
                >
                  Save
                </button>
                <button
                  class="button-square red"
                  @click="resetEditableModel()"
                  v-if="isEditing"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div class="footer-btn-group" v-if="isEditable && isSubmitting">
              <div class="loader"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as jsPDF from 'jspdf';
import dayjs from 'dayjs';
import { utils, http } from '../digilib_web/core/digitify';
import { constants, regentsUtils } from '../js/regents';

export default {
  props: {
    model: Object,
    month: Number,
    year: [Number, String],
    isEditable: Boolean,
    profile: Object,
    notif: Object
  },
  data() {
    return {
      earningFields: [
        'salary',
        'functional_allowance',
        'food_transport_allowance',
        'discipline_bonus',
        'thr',
        'travel_bonus',
        'end_year_bonus',
        'penambahan'
      ],
      deductionFields: [
        'bpjs_tenaker_contrib',
        'bpjs_kesehatan_contrib',
        'reksadana_contrib',
        'cashbon',
        'pengurangan'
      ],
      isEditing: false,
      isSubmitting: false,
      loading: true,
      monthlyAttendance: null,
      countLate: 0,
      editableModel: Object.assign({}, this.model)
    };
  },
  mounted() {
    let idEmp = this.model.id_employee;
    let endpoint = `employees/attendance/monthly/${this.month}/${
      this.year
    }?where=id_employee,=,${idEmp}`;
    http.get(endpoint).then(json => {
      console.log(json);

      this.monthlyAttendance = json.data;
      if (this.monthlyAttendance.length > 0) {
        let curYear = this.year;
        let endpoint = `employees/attendance?select=clock_in,clock_out&where=id_employee,=,${idEmp}|date,>=,${curYear}-01-01|date,<=,${curYear}-12-31`;
        http.get(endpoint).then(json => {
          let department = this.monthlyAttendance[0].department;
          this.countLate = regentsUtils.countAnnualLateness(
            json.data,
            department
          );
          this.loading = false;
        });
      }
    });
  },
  computed: {
    editableFields() {
      return [...this.earningFields, ...this.deductionFields, 'note'];
    },
    totalAttendanceDeductions() {
      let deductions = 0;
      // deduct from attendance after the 10th lateness
      if (this.monthlyAttendance) {
        let m = this.monthlyAttendance;
        for (let i = 0; i < m.length; ++i) {
          let isAfterPaymentDate = dayjs(m[i].date).isAfter(
            dayjs(this.model.payment_date).add(1, 'day')
          );
          // add the deduction if it's before the payment date
          if (!isAfterPaymentDate) {
            let row = regentsUtils.attendanceDeduction(m[i], this.countLate);
            if (row.deduction) {
              deductions += row.deduction;
            }
          }
        }
      }
      return deductions;
    },
    total() {
      let model = this.editableModel;
      let total = -this.totalAttendanceDeductions;
      // iterate over earnings and deductions to get the total
      // exclude jamsostek allowance
      this.earningFields.forEach(k => {
        total += model[k];
      });
      this.deductionFields.forEach(k => {
        total -= model[k];
      });
      return `Rp. ${total.toLocaleString()}`;
    },
    payDay() {
      return `Pay Day: ${dayjs(this.model.payment_date).format('DD MMM YYYY')}`;
    },
    monthStr() {
      return constants.MONTHS.find(x => x.id === this.month).name;
    },
    tableItems() {
      let isExpat = this.model.is_expat;
      let basicItems = [
        { desc: 'Base Salary', id: 'salary' },
        { desc: 'Functional Allowance', id: 'functional_allowance' },
        { desc: 'Food & Transport', id: 'food_transport_allowance' },
        { desc: 'Discipline Bonus', id: 'discipline_bonus', overridable: true },
        { desc: 'Adjustment', id: 'penambahan', overridable: true }
      ];
      let deductions = [
        {
          desc: 'BPJS Ketenagakerjaan Contribution',
          id: 'bpjs_tenaker_contrib',
          isDeduct: true
        },
        {
          desc: 'BPJS Kesehatan Contribution',
          id: 'bpjs_kesehatan_contrib',
          isDeduct: true
        },
        {
          desc: 'Reksadana Contribution',
          id: 'reksadana_contrib',
          isDeduct: true
        },
        { desc: 'Cashbon', id: 'cashbon', isDeduct: true, overridable: true },
        {
          desc: 'Adjustment',
          id: 'pengurangan',
          isDeduct: true,
          overridable: true
        }
      ];
      let expatItems = [
        { desc: 'Travel Bonus', id: 'travel_bonus', overridable: true },
        { desc: 'End Year Bonus', id: 'end_year_bonus', overridable: true }
      ];
      let localItems = [{ desc: 'THR', id: 'thr', overridable: true }];
      if (isExpat) {
        return [...basicItems, ...expatItems, ...deductions];
      }
      return [...basicItems, ...localItems, ...deductions];
    }
  },
  methods: {
    toRupiah(v) {
      return `Rp. ${v.toLocaleString()}`;
    },
    resetEditableModel() {
      this.isEditing = false;
      this.editableModel = JSON.parse(JSON.stringify(this.model));
    },
    updateEditable() {
      this.isSubmitting = true;
      // cherry pick the editable stuff only
      let payload = utils.partialCopy(this.editableModel, this.editableFields);
      // console.log(this.editableModel, payload)
      http.put(`employees/payslips/${this.model.id}`, payload).then(json => {
        this.$emit('update:notif', utils.notif('Payslip updated!', json));
        if (json.success) {
          this.$emit('update:model', this.editableModel);
          this.isSubmitting = false;
        }
      });
    },
    download() {
      let model = this.model;
      let logo = this.$refs.logo;
      let canvas = document.createElement('canvas');
      canvas.width = logo.width;
      canvas.height = logo.height;
      let ctx = canvas.getContext('2d');
      ctx.drawImage(logo, 0, 0);
      let dataURL = canvas
        .toDataURL('image/png')
        .replace(/^data:image\/(png|jpg);base64,/, '');
      canvas = null;
      let earnings = utils.partialCopy(model, this.earningFields);
      let deductions = utils.partialCopy(model, this.deductionFields);
      deductions.attendance = this.totalAttendanceDeductions;
      let PdfPrinter = jsPDF;
      let doc = new PdfPrinter();
      let fontSize = 10;
      doc.setFontSize(fontSize);
      doc.setTextColor(0, 0, 0);
      let x = 11;
      let y = 40;
      let ySpacing = 6;
      doc.addImage(dataURL, 'JPEG', x, y - 30, 50, 20);
      doc.setFontSize(fontSize + 2);
      doc.text(x, y, model.employee_name);
      let cur = dayjs(model.payment_date).format('25 MMM');
      let prev = dayjs(model.payment_date)
        .subtract(1, 'month')
        .format('26 MMM');
      let year = dayjs(model.payment_date).format('YYYY');
      doc.setFontSize(fontSize);
      doc.text(165, y, `${prev} - ${cur} ${year}`);
      y += ySpacing;
      if (model.employee_no) {
        doc.text(x, y, `Employee Number : ${model.employee_no}`);
      }
      y += ySpacing;
      // payslip details
      let boxW = 190;
      let boxHeaderH = 12;
      let paddingT = 2;
      let paddingL = 2;
      let earningX = 110;
      let deductionX = 150;
      doc.rect(x, y, boxW, boxHeaderH);
      doc.rect(earningX, y, 0.1, boxHeaderH, 'F');
      doc.text(earningX + paddingL, y + paddingT * 4, 'Earnings');
      doc.rect(deductionX, y, 0.1, boxHeaderH, 'F');
      doc.text(deductionX + paddingL, y + paddingT * 4, 'Deductions');
      y += boxHeaderH;
      doc.rect(x, y, boxW, 0.1, 'F');
      let boxStartY = y;
      let boxBorderH = 0;
      let earningsTot = 0;
      let deductionsTot = 0;
      for (let k in earnings) {
        if (earnings[k] > 0) {
          y += ySpacing;
          if (k === 'jamsostek_allowance') {
            doc.setFontType('italic');
            doc.text(
              x + paddingL,
              y,
              `Jamsostek Allowance - this is what the school paid in for you`
            );
            doc.text(earningX + paddingL, y, `(${this.toRupiah(earnings[k])})`);
            doc.setFontType('normal');
          } else {
            let it = this.tableItems.find(x => x.id === k);
            let desc = it ? it.desc : k[0].toUpperCase() + k.substring(1);
            doc.text(x + paddingL, y, desc);
            doc.text(earningX + paddingL, y, this.toRupiah(earnings[k]));
            earningsTot += earnings[k];
          }
          y += paddingT;
          doc.rect(x, y, boxW, 0.1, 'F');
          boxBorderH += paddingT + ySpacing;
        }
      }
      for (let k in deductions) {
        if (deductions[k] > 0) {
          y += ySpacing;
          let it = this.tableItems.find(x => x.id === k);
          let desc = it ? it.desc : k[0].toUpperCase() + k.substring(1);
          doc.text(x + paddingL, y, desc);
          doc.text(deductionX + paddingL, y, this.toRupiah(deductions[k]));
          y += paddingT;
          doc.rect(x, y, boxW, 0.1, 'F');
          boxBorderH += paddingT + ySpacing;
          deductionsTot += deductions[k];
        }
      }
      // border left and right
      doc.rect(x, boxStartY, 0.1, boxBorderH, 'F');
      doc.rect(earningX, boxStartY, 0.1, boxBorderH, 'F');
      doc.rect(deductionX, boxStartY, 0.1, boxBorderH, 'F');
      doc.rect(x + boxW, boxStartY, 0.1, boxBorderH, 'F');
      // sub total
      y += 0.1;
      let boxTotalW = 10;
      let totalOffsetX = 30;
      let totalPaddingT = paddingT * 3;
      doc.rect(deductionX, y, 0.1, boxTotalW, 'F');
      doc.text(earningX - totalOffsetX, y + totalPaddingT, 'SUBTOTAL:');
      doc.text(
        earningX + paddingL,
        y + totalPaddingT,
        this.toRupiah(earningsTot)
      );
      doc.text(
        deductionX + paddingL,
        y + totalPaddingT,
        this.toRupiah(deductionsTot)
      );
      doc.rect(earningX, y, boxW - earningX + x, boxTotalW);
      y += boxTotalW;
      doc.text(earningX - totalOffsetX, y + totalPaddingT, 'GRAND TOTAL:');
      doc.rect(earningX, y, boxW - earningX + x, boxTotalW);
      doc.text(
        deductionX - 10,
        y + totalPaddingT,
        this.toRupiah(earningsTot - deductionsTot)
      );
      // note
      if (model.note) {
        doc.text(x, y + 30, `Note : ${model.note}`);
      }
      // footer
      doc.setTextColor(134, 151, 189);
      let footers = [
        {
          title: 'PRESCHOOL',
          address: 'Jl Dewi Madri 58 Sumerta Klod,',
          city: 'Denpasar Timur - Bali',
          phone: '+62 361 472 3040',
          email: 'preschool@regentsschoolbali.com'
        },
        {
          title: 'PRIMARY',
          address: 'Jl Badak Agung 23X, Sumerta Klod',
          city: 'Denpasar Timur - Bali',
          phone: '+62 361 472 3090',
          email: 'primary@regentsschoolbali.com'
        },
        {
          title: 'SECONDARY',
          address: 'Jl Dewi Madri 58 Sumerta Klod,',
          city: 'Denpasar Timur - Bali',
          phone: '+62 361 449 3499',
          email: 'secondary@regentsschoolbali.com'
        }
      ];
      let xFooter = x;
      let yStartFooter = 250;
      let yFooter = yStartFooter;
      footers.forEach(footer => {
        for (let k in footer) {
          doc.text(xFooter, yFooter, footer[k]);
          yFooter += 5;
        }
        xFooter += 66;
        yFooter = yStartFooter;
      });
      // footer text
      doc.setTextColor(0, 0, 0);
      let yStartFooterText = 280;
      doc.text(
        x,
        yStartFooterText,
        'Dicetak dengan menggunakan Regents HR Portal by Biblio Systems.'
      );
      yStartFooterText += 5;
      doc.text(
        x,
        yStartFooterText,
        'Slip gaji ini tidak membutuhkan tanda tangan.'
      );
      yStartFooterText += 5;
      doc.text(
        x,
        yStartFooterText,
        'Untuk konfirmasi, silahkan hubungi HR Regents School: hrd@regentsschoolbali.com'
      );
      // download
      let month = dayjs(model.payment_date).format('MMM_YYYY');
      doc.output('save', `${month}payslips.pdf`);
    }
  }
};
</script>

<style>
.header-group {
  display: flex;
  justify-content: space-between;
}
.box {
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.5);
}
.box-header-group {
  display: flex;
  justify-content: space-between;
  background-color: #ecf0f1;
  padding: 10px;
}
.box-content-group {
  padding: 10px;
  display: flex;
  flex-flow: column;
}
.emp-details-group {
  display: flex;
  justify-content: space-between;
  line-height: 2em;
}
.green-label {
  color: #5fb1a0;
}
.red-label {
  color: #cf000f;
}
.footer {
  margin-top: 50px;
}
.footer-btn-group {
  display: flex;
  justify-content: center;
}
.table-value-group {
  display: flex;
  justify-content: space-between;
}
.table-value-group > i {
  color: #39a2d9;
  cursor: pointer;
}
.table-value-group > input {
  padding: 0.5em;
  border: 1px solid #cecece;
  font-size: 0.9rem;
  color: #464a4c;
  height: 28px;
  border-radius: 0.2rem;
}
table {
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.5);
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: 0.35em;
}
tbody tr:nth-child(odd) {
  background-color: white;
}
tbody td,
thead td {
  border: 1px solid #dddddd;
}
tfoot td {
  background-color: white;
  font-weight: bold;
}
table th,
table td {
  padding: 0.625em;
}
table th {
  font-size: 0.85em;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
@media screen and (max-width: 640px) {
  .emp-details-group {
    flex-flow: column;
  }
  .table-value-group > input {
    width: 100px;
  }
}
</style>
